"use strict";
// Shared contracts between the API and the web app.
// Keep this package free of runtime dependencies — types, enums and small helpers only.
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAX_PAGE_SIZE = exports.DEFAULT_PAGE_SIZE = exports.Roles = void 0;
/** RBAC roles stored on each Employee (Employee.roles). */
exports.Roles = {
    ADMIN: 'admin',
    USER: 'user',
    TEAM_LEAD: 'team-lead',
    CUSTOMER_CARE: 'customer-care',
};
exports.DEFAULT_PAGE_SIZE = 25;
exports.MAX_PAGE_SIZE = 100;
